.titleContent {
	height: 44px;
	overflow-y: auto;
	padding-right: 4px;
}

.tooltipContent {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
